<template>
  <div id="app" :class="{'version_en': language == 'en'}">
    <template v-if="meta && !isEmptyObject(meta)">
      <!-- <DashHeader3 v-if="meta.head == 2 || meta.head == 3" class="homeHeader" />
      <DashHeader  v-if="meta.head != 2 && meta.head != -1 && meta.head != 3" />
      <menuItem    v-if="meta.head != 2 && meta.head != -1 && meta.head != 3" :class="{'grayBackground': meta.whiteBackground}" /> -->
    </template>
    <div :key="Key">
      <!-- 需要缓存 -->
      <keep-alive>
        <!-- <router-view
          v-if="$route.meta.keepAlive"
          :class="{ 'p-t-118': meta.head == 3 || meta.head == 2, 'p-t-68': meta.head != 2 && meta.head != -1 && meta.head != 3 }"
        /> -->
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <!-- 不需要缓存 -->
      <!-- <router-view v-if="!$route.meta.keepAlive"
        :class="{ 'p-t-118': meta.head == 3 || meta.head == 2, 'p-t-68': meta.head != 2 && meta.head != -1 && meta.head != 3 }" /> -->
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <!-- <ChatMedia v-if="(isHttps && !isIE && showMedia) || (webIMDebug && showMedia)" /> -->
    <!-- <ChatWithEmployee /> -->
    <!-- <noticeDialog></noticeDialog> -->
    <!-- <noticeDialogActor></noticeDialogActor> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import webIMConfig from '@/utils/webIMConfig'
import { browser } from '@/utils/function'
// import ChatWithEmployee from '@/components/chat/ChatWithEmployee'
import ChatMedia from '@/components/chat/ChatMedia'
import DashHeader from '@/components/head/DashHeader'
import DashHeader3 from '@/components/head/indexHeader.vue'
import noticeDialog from '@/components/dialog/noticDialog.vue'
import noticeDialogActor from '@/components/dialog/noticDialogActor.vue'

import menuItem from '@/components/head/menuItem'
import { noticeListType } from '@/api/index'

export default {
  components: {
    // ChatWithEmployee,
    ChatMedia,
    DashHeader,
    DashHeader3,
    menuItem,
    noticeDialog,
    noticeDialogActor
  },
  // 添加多语言metaInfo配置
  metaInfo() {
    const isChinese = this.$store.getters.language !== 'en';

    if (isChinese) {
      return {
        title: 'CAC - 中国国际农用化学品及植保展览会',
        meta: [
          {
            name: 'description',
            content: '中国国际农用化学品及植保展览会,于 1999 年首次举办。第二十六届中国国际农用化学品及植保展览会（CAC2026）将在国家会展中心（上海）1.2 馆、2.2 馆、5.2 馆、6.2 馆、7.2 馆、8.2 馆举办,展出面积达到 16 万平方米。 CAC2026 展期将举办中国国际植保展览会（CropProtection）、中国国际新型肥料展览会（FSHOW）、中国国际农化装备及植保器械展览会（CACE）、中国国际现代农业科技展览会（AgTech）及 CAC 会议周（CACW）等分题展览及行业专题会议,届时将有 2,200 余家知名展商汇聚在农化的世界,与 100,000余人次的海内外业内人士共商世界的农化。'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    } else {
      return {
        title: 'CAC - China International Agrochemical & Crop Protection Exhibition',
        meta: [
          {
            name: 'description',
            content: 'China International Agrochemical& Crop Protection Exhibition (CAC),was first launched in 1999. CAC2026 will be held at National Exhibition and Convention Center (Shanghai),at Halls 1.2,2.2,5.2,6.2,7.2 and 8.2,with a total exhibition space of 160,000 square meters. CAC2026 features several sub-exhibitions and industry conferences,including China International Crop Protection Exhibition(CropProtection),China International Fertilizer Show (FSHOW),China International Agrochemical & Crop Protection Equipment Exhibition(CACE),and China International AgTech Exhibition (AgTech),as well as CAC Conference Week (CACW). CAC2026 will bring together more than 2,200 leading exhibitors and over 100,000 attendance of industry professionals from home and abroad to explore globalagrochemical developments.'
          },
          {
            name: 'keywords',
            content: '植保器械展会,农药原药展会,农业机械展会,上海农化展览会,生物农药展会,农化装备展会,中国国际农药展,中国农药展会,最近农展会,中国(上海)国际农用化学品及植保展览会,助农展销会,农药展销会在哪里举办,农药展览,上海近期农展会,中国肥料展,农药中间体展会,农药展会,农药展销会,肥料展会,上海农化展会,中国农药展览会,中国农展会,上海农药原药展览会,上海农展会在什么地方,上海农资展会,国际农化展,上海农展会,上海农化展,农化展会,植保展会,农化展2026,2026上海农药展,近期农业展会,2026杭州农药展会,cac农化展2026,2026植保展,农业展会2026,2026上海农药展会,2026农展会,2026年农展会,农药展会2026时间表,农业展会2026时间表,2026年农资展览会,上海农药展会2026,上海农化展会2026,2026年农资展会时间表,2026年农业展会有哪些,2026植保展会,2026年农药展会,2026农化展,2026年农产品展会,农药展2026,2026农资展会,植保展,农展网,2026年全国农药展览会,农资展会,2026上海国际农药助剂展览会,2026年植保展会时间表,2026年农产品展览会,2026年农资展会,上海cac农化展,化肥展,北京农展会,上海国际农化展,2026年农药展会时间表,2026农药展览会,农展会,2026农药展,农资展览,全国农药展会,全国农业展会,青岛农药展会,农业展览馆近期展会,上海肥料展,上海肥料展会,国际农业展会,上海植保展,农展会信息,2026农产品展会,新型肥料展会,上海国际农化展cac,农资展览会,农资展销会,农化产品展,cac农药展2026,农展会2026年时间表格,2026农化展会,农业展会2026年,全国农药交流会暨农化产品展览会,上海植保展会,微生物农药研究进展,全国植保展,肥料展览会,国内农业展会,ace农药展会,中国国际肥料展览会,ace农药展,上海农药展,上海农药展会,上海原药展,cac农药展,农业设备展会,农业展销会博览会,农牧展会,农药助剂展,国际肥料展会,国际肥料展览会,cac农化展,农展馆最近展会,农化展,农药展览会,上海农药助剂展,农药展,cac上海农药展会,北京农展,农展,2026农药展会,全国农展会,全国农药交流会暨农化产品展览会,2026年中国农产品展览会,肥料展,农药国际展会,农药化肥展会,农用化学品（agrochemical）,农药（pesticide）,肥料（fertilizer）,植保（Crop protection）,herbicide (除草剂),insecticide （杀虫剂）,fungicide （杀菌剂）, biopesticide,Seed,specialty fertilizer (特种肥),npk（氮磷钾）,compound fertilizer（复合肥）'
          }
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://cacizt-pc.eastfair.com/'
          }
        ]
      };
    }
  },
  data() {
    return {
      Key: '',
      webIMDebug: webIMConfig.isDebug,
      showMedia: webIMConfig.showMedia,
      isIE: browser.trident,
      isHttps: window.location.protocol === 'https:'
    }
  },
  computed: {
    meta: function() {
      return this.$route.meta || ''
    },
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'isTIM', 
      'customerServiceInfo',
      'currentUserProfile',
      'conversationList'
    ]),
  },
  watch: {
    $route() {
      const meta = this.$route.meta
      this.Key = new Date().getTime()

      // 设置背景色
      if(meta) {
        setTimeout(() => {
          let body = document.querySelector('body')
          if (! body) return
          if (meta.whiteBackground) {
            body.classList.add('bodyWhite')
          } else {
            body.classList.remove('bodyWhite')
          }
        }, 0)
      }
    },
    isLogin: {
      handler() {
        // if (!this.isLogin) {
        //   clearInterval(this.timers)
        //   this.timers = null
        // } else {
        //   this.timers = setInterval(() => {
        //     // 定时器操作
        //     this.getList()
        //   }, 60000)
        // }
      },
      // deep: true
    }
  },
  async mounted() {
    console.log('英文')
    if (this.isIE) {
      this.$notify({
        title: this.$t('Confirm'),
        message: this.$t('Chat features will not work if you keep using IE, please try other brwosers'),
        type: 'warning',
        duration: 0
      })
    }

    this.globalListening()
    this.getFromUrl()
    this.getInvitation()
  },
  methods: {
    /** 全局监听
     * 网络监听
     * 消息监听
     */
    globalListening() {
      // this.$nextTick(() => {
      //     if (this.isLogin) {
      //         this.timers = setInterval(() => {
      //         // 定时器操作
      //         this.getList()
      //         }, 60000)
      //     }
      // })

      const onLine = () => {
        this.$notify.success({
          message: this.$t('onLine')
        })
      }
      const offLine = () => {
        this.$notify.error({
          message: this.$t('offLine')
        })
      }

      window.addEventListener('online', onLine, false)
      window.addEventListener('offline', offLine, false)

      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('online', onLine)
        window.removeEventListener('offline', offLine)

        // if (this.timers) {
        //     clearInterval(this.timers)
        //     this.timers = null
        // }
      })
    },
    // 收集广告位分享的来源
    getFromUrl() {
      let search = window.location.search
      if (!search) return
      search = search.substr(1)
      let pathName = window.location.pathname
      let origin = window.location.origin
      let logsPath = ['/login', '/'] //埋点的地址
      let params = this.parser(search)
      if (params.fromUrl) {
        this.$store.commit('SET_FROMURL', params.fromUrl)
      }
      if (!logsPath.includes(pathName)) return
      this.$store.commit('SET_ADVERTISING_SHARING', origin + pathName)
    },
    /**
     * 收集展商邀请函的来源
     * 展商通过邀请函 给 客商邮箱 发送 参加展会的邮件（本展商的详情）
     */
    getInvitation() {
      let sendPath = ['/find-exhibitor/detail/', '/find-exhibit/detail/']
      let pathName = window.location.pathname
      let search = window.location.search
      if (!pathName || sendPath.includes(pathName)) return
      if (!search) return
      search = decodeURIComponent(search)
      search = search.substr(1)
      let params = this.parser(search)
      let id
      if (!params.email || !params.userAccountId) return
      if (params.exhibitorId) {
        id = params.exhibitorId
      } else {
        id = pathName.split("/")
        id = id[id.length - 1]
      }
      if (/([0-9A-Za-z]{10,}$)/.test(id) === false) return
      if (params.userAccountId) {
        this.$store.commit('SET_INVITATION_SOURCE', {
          exhibitorId: id,
          exhibitorEmployeeUserAccountId: params.userAccountId,
          email: params.email
        })
        this.invitationStatistics()
      }
    },
    getList() {
      if (this.isLogin && (this.subjectType == 'ACTOR' || this.subjectType == 'VISITOR')) {
        noticeListType({}).then(res => {
          var noticeListArr
          var inviteSeen = true
          var sponsorSeen = true
          var checkresultSeen = true
          var intentionorderSeen = true
          noticeListArr = res.data.data || []
          if (noticeListArr.length > 0) {
            for (let i in noticeListArr) {
              if (noticeListArr[i]['noticeType'] == 'SPONSOR') {
                sponsorSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'CHECKRESULT') {
                checkresultSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'INVITE') {
                inviteSeen = noticeListArr[i]['seen']
              }
              if (noticeListArr[i]['noticeType'] == 'INTENTIONORDER') {
                intentionorderSeen = noticeListArr[i]['seen']
              }
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="stylus">
@import url('//at.alicdn.com/t/font_1810802_bl4de3d581h.css');
@import './styles/reset'
@import './styles/style'
@import './styles/dash'
@import './styles/home'
@import './styles/loginAndRegister'
@import './styles/respon'
@import './styles/hotspot'

* {
  outline none
}
html, body{
  height 100%
}
body
  min-width $container-width-min
  background $color-gray-fb
  overflow auto
  font-family Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif
  // font-family: OpenSans, "siyuan"
  font-family: OpenSans, 'pingfang';
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  // max-width 1920px


&.bodyWhite {
  background $color-white
}
.iconfont,
.iconfont-el
  font-size 14px
  margin 9px 8px
  min-width 14px
#app
  color #2c3e50
  min-height 100vh
#nprogress .bar
  background $color-main !important
.v-live-rotate-1 .vcp-video,.v-live-rotate-1 video{
  transform:rotate(90deg)
}
.v-live-rotate-2 .vcp-video,.v-live-rotate-2 video{
  transform:rotate(180deg)
}
.v-live-rotate-3 .vcp-video,.v-live-rotate-3 video{
  transform:rotate(270deg)
}
</style>
